import { Pipe, PipeTransform } from '@angular/core';

import { CmpsDecimalPipe } from '../../common/number.pipe';
import { Compensation } from '../scorecard.model';

@Pipe({
    name: 'cmpsCompDesc',
})
export class CompensationDescriptionPipe implements PipeTransform {
    constructor(private readonly _decimalPipe: CmpsDecimalPipe) {}

    transform(value: string, comp: Compensation, ...args: any[]): any {
        let result = value;
        if (result) {
            result = result.replace(
                '{{ConditionValue}}',
                this._decimalPipe.transform(comp.conditionValue, '1.0-2'),
            );
            result = result.replace(
                '{{EffectValue}}',
                this._decimalPipe.transform(comp.effectValue, '1.0-2'),
            );
            try {
                result = result.replace(
                    '{{LowerRange}}',
                    this._decimalPipe.transform(
                        parseFloat(comp.lowerRange),
                        '1.0-2',
                    ),
                );
            } catch {}
            try {
                result = result.replace(
                    '{{UpperRange}}',
                    this._decimalPipe.transform(
                        parseFloat(comp.upperRange),
                        '1.0-2',
                    ),
                );
            } catch {}
        }
        return result;
    }
}
